export class UpdateManualDataModel {
    public id: any;
    public sc_emp_id: string;
    public cal_run_id: any;
    public kpi_id: number;
    public comm_plan_id: number;
    public adjustment: any;
    public adjustment_comments: string;
    public commission_period: string;
    public kpi: string;
    public yield_goal: any;
    public comm_plan_type: string;
    public upload_type: string;
    public kpi_name: string;
    public kpiid: number;
    public commplanid: number;
    public commplanname: string;
    public calrunid: number;
    public type: string;
    public empname: string;

    constructor() {
        this.empname = null;
        this.adjustment = null;
        this.adjustment_comments = null;
        this.commission_period = null;
        this.kpi = null;
        this.type = null;
        this.calrunid = null;
        this.commplanid = null;
        this.commplanname = null;
        this.kpi_name = null;
        this.kpiid = null;
        this.id = null;
        this.sc_emp_id = null;
        this.cal_run_id = null;
        this.kpi_id = null;
        this.comm_plan_id = null;
        this.yield_goal = null;
        this.comm_plan_type = null;
        this.upload_type = null;
    }
}
